import React, { useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  DatePicker,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSearchApiSearchText } from '../../../network/itemList';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import dayjs from 'dayjs';
const ExpensesList = ({
  setDataSourceExpenses,
  dataSourceExpenses,
  costCenterData,
  t,
  form,
}) => {
  const [count, setCount] = useState(0);
  const [setTextAccount, setSetTextAccount] = useState('');
  const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
  const { data: expenses } = useQuery({
    queryKey: [queryKeys.getSearchApiExpenseClaim, setTextAccount],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Expense Claim Type',
        searchTxt: setTextAccount,
      }),
    keepPreviousData: true,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch, searchTextCostCenter],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Cost Center',
        searchTxt: searchTextCostCenter,
      }),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.expenseDate,
      dataIndex: 'expense_date',
      render: (text, record, index) => (
        <DatePicker
          placeholder={t.expenseDate}
          format="YYYY-MM-DD"
          style={{ width: '100%' }}
          value={dayjs(record.expense_date)}
          onChange={(date) => {
            const newDataSource = [...dataSourceExpenses];
            newDataSource[index] = {
              ...newDataSource[index],
              expense_date: date,
            };
            setDataSourceExpenses(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.expenseType,
      dataIndex: 'expense_type',
      render: (text, record, index) => (
        <Select
          placeholder={t.expenseType}
          style={{ width: '100%' }}
          filterOption={false}
          showSearch
          value={record.expense_type}
          onSearch={(value) => {
            setSetTextAccount(value);
          }}
          options={expenses?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
            option: item,
          }))}
          onChange={(value, option) => {
            // console.log(option,"fieuwhfieuwfhweif");
            const newDataSource = [...dataSourceExpenses];
            newDataSource[index] = {
              ...newDataSource[index],
              expense_type: value,
            };
            setDataSourceExpenses(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          style={{ width: '100%' }}
          value={record.amount}
          type="number"
          min={0}
          onChange={(e) => {
            const newDataSource = [...dataSourceExpenses];
            newDataSource[index] = {
              ...newDataSource[index],
              amount: e.target.value,
              sanctioned_amount: e.target.value,
            };
            setDataSourceExpenses(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.sanctionedAmount,
      dataIndex: 'sanctioned_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.sanctionedAmount}
          style={{ width: '100%' }}
          value={record.sanctioned_amount}
          type="number"
          min={0}
          onChange={(e) => {
            const newDataSource = [...dataSourceExpenses];
            newDataSource[index] = {
              ...newDataSource[index],
              sanctioned_amount: e.target.value,
            };
            setDataSourceExpenses(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.costCenter,
      dataIndex: 'cost_center',
      render: (text, record, index) => (
        <Select
          placeholder={t.costCenter}
          popupMatchSelectWidth={false}
          showSearch
          optionFilterProp="children"
          filterOption={false}
          style={{ width: '100%' }}
          value={record.cost_center}
          // filterSort={(optionA, optionB) =>
          //   (optionA?.label ?? '')
          //     .toLowerCase()
          //     .localeCompare((optionB?.label ?? '').toLowerCase())
          // }
          options={costCenters?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onSearch={(value) => {
            setSearchTextCostCenter(value);
          }}
          onChange={(value) => {
            const newDataSource = [...dataSourceExpenses];
            newDataSource[index] = {
              ...newDataSource[index],
              cost_center: value,
            };
            setDataSourceExpenses(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      uom: '',
      cost_center: costCenterData ? costCenterData : '',
      conversion_factor: '',
    };
    setDataSourceExpenses((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceExpenses.filter((item) => item.key !== key);
    setDataSourceExpenses(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceExpenses}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default ExpensesList;
